<template>
    <div>
        <div class="d-flex flex-column align-items-center" style="margin-top: 30px;">
            <div>
                <div class="row">
                    <div class="board-container">
                        <template v-if="Array.isArray(imageProperties) && imageProperties.length > 0">
                            <div v-for="(image, index) in imageProperties" :key="index">
                                <img :src="image" alt="Property Image"
                                    :class="{ 'base-image': true, 'grayscale': !isImageSelected(index) }"
                                    @click="handleImageClick($event, index)" />
                            </div>
                        </template>
                        <template v-else>No images available.</template>
                    </div>

                    <div class="d-flex justify-content-end progress-container mt-2 mb-2">
                        <span>Elementos:<span style="color: #00B5F3;">{{ foundImagesCount }}/{{ imageProperties.length
                                }}</span></span>
                    </div>

                    <div class="progress-container position-relative">
                        <el-progress :percentage="progressPercentage" :color="progressColor" :stroke-width="12"
                            :show-text="false"></el-progress>
                        <div class="progress-dots">
                            <div v-for="(dot, index) in dotPositions" :key="index" :style="getDotStyle(dot)"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div @click="handleContainerClick" class="main-content">
                <div class="game-board-searching">
                    <div class="position-relative">
                        <div class="">
                            <img ref="mainImage" :src="properties?.main_image" alt="Imagen"
                                class="img-fluid d-block w-100" @click="handleImageClick" />

                            <div class="position-absolute top-0 start-0 w-100 h-100" ref="coordinateContainer">
                                <div v-for="(coord, index) in coordinates" :key="index"
                                    :style="getCoordinateStyle(coord)" @click="handleCoordinateClick(coord, $event)">
                                   <div class="coordinate-marker">
                                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                            viewBox="0 0 10 10" fill="none">
                                            <circle cx="5" cy="5" r="5" fill="#00B5F3" />
                                        </svg> -->
                                    </div>
                                    <!-- <img :src="coord.image" alt="Coordinate Image" class="w-50 h-50 d-none" /> -->
                                    <div v-if="selectedCoordinates.some(c => c.x === coord.x && c.y === coord.y)"
                                        class="highlight-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                            viewBox="0 0 40 40" fill="none">
                                            <path
                                                d="M20 3.125C16.6624 3.125 13.3998 4.1147 10.6248 5.96895C7.84968 7.8232 5.68677 10.4587 4.40954 13.5422C3.13231 16.6257 2.79813 20.0187 3.44926 23.2921C4.10038 26.5656 5.70757 29.5724 8.06758 31.9324C10.4276 34.2924 13.4344 35.8996 16.7079 36.5508C19.9813 37.2019 23.3743 36.8677 26.4578 35.5905C29.5413 34.3132 32.1768 32.1503 34.0311 29.3752C35.8853 26.6002 36.875 23.3376 36.875 20C36.87 15.526 35.0906 11.2367 31.927 8.07305C28.7634 4.90945 24.474 3.12996 20 3.125ZM20 33.125C17.4041 33.125 14.8665 32.3552 12.7081 30.913C10.5498 29.4708 8.86749 27.421 7.87409 25.0227C6.88069 22.6244 6.62077 19.9854 7.1272 17.4394C7.63363 14.8934 8.88367 12.5548 10.7192 10.7192C12.5548 8.88366 14.8934 7.63362 17.4394 7.12719C19.9854 6.62076 22.6244 6.88068 25.0227 7.87408C27.421 8.86748 29.4709 10.5497 30.913 12.7081C32.3552 14.8665 33.125 17.4041 33.125 20C33.1213 23.4798 31.7373 26.8161 29.2767 29.2767C26.8161 31.7373 23.4798 33.1213 20 33.125Z"
                                                fill="#00B5F3" />
                                        </svg>
                                    </div>
                                </div>
                                <div v-if="showError" class="z-3 position-absolute" :style="getErrorStyle()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                        fill="none">
                                        <circle cx="20" cy="20" r="18" stroke="#FF0000" stroke-width="2" />
                                        <line x1="12" y1="12" x2="28" y2="28" stroke="#FF0000" stroke-width="2" />
                                        <line x1="28" y1="12" x2="12" y2="28" stroke="#FF0000" stroke-width="2" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal imagen encontrada -->
        <el-dialog :visible.sync="modalMatch" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
            :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" :center="true"
            class="custom-dialog">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <img v-if="modalImage" :src="modalImage" alt="Imagen" class="img-fluid">
                <h5 class="mb-1 mt-3 text-title-bat" v-if="modalTitle">{{ modalTitle }}</h5>
                <p class="text-bat" v-if="modalDescription">{{ modalDescription }}</p>
                <el-button type="primary" class="btn btnBlue" @click="closeModal">Aceptar</el-button>
            </div>
        </el-dialog>

        <!-- Modal al finalizar el reto -->
        <el-dialog :visible.sync="modalExit" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
            :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" :center="true"
            class="custom-dialog">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break p-3">
                <img src="/../img-version2/icons/cup.svg" alt="Imagen" class="img-fluid">
                <h5 class="mb-1 mt-3 text-title-bat">¡Felicitaciones!</h5>

                <h6 v-if="isLinked" class="text-bat">completaste tu reto, has ganado <strong>{{entertainment.points_to_win}} puntos</strong></h6>
                <h6 v-else class="text-bat">completaste tu reto</h6>

                <el-button type="primary" class="btn btnBlue" @click="returnChallenge()">Aceptar</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
        url_storage: {
            default: null,
        },
        entertainment: {
            default: null,
        },
        properties: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            dotPositions: [30, 43, 57, 70],
            imagesCompleted: [],
            imageProperties: [],
            selectedImage: null,
            selectedImages: [],
            coordinates: [],
            imageSize: { width: 0, height: 0 },
            selectedCoordinates: [],
            showError: false,
            errorPosition: { x: 0, y: 0 },
            foundImagesCount: 0,
            modalMatch: false,
            modalTitle: '',
            modalImage: '',
            modalDescription: '',
            parsedProperties: [],
            modalExit: false,

            isLinked: false,
        };
    },
    mounted() {
        this.initializeProperties();
        this.$refs.mainImage.addEventListener('load', this.onImageLoad);
        document.addEventListener('click', this.handleOutsideClick);
        this.validateLinkingDate();

    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    computed: {
        progressPercentage() {
            if (this.imageProperties.length === 0) {
                return 0;
            }
            return (this.imagesCompleted.length / this.imageProperties.length) * 100;
        }
    },
    methods: {
        finished() {
            const puntosGanados = this.entertainment.points_to_win;
            axios.post('store', { 'entertainment_id': this.entertainment.id, 'total': puntosGanados }).then((response) => {
                if (response.data.status === 'success') {
                    this.pointsEarned = puntosGanados;
                    this.modalExit = true;
                } else {
                    alert('Ha ocurrido un error al guardar el reto');
                }
            });
        },

        getDotStyle(percentage) {
            const position = Math.min(Math.max(percentage, 0), 100) + '%';
            return {
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)'
            };
        },

        isImageSelected(index) {
            return this.selectedImages.includes(index);
        },

        isCoordinateCorrect(coord) {
            return this.coordinates.some(c => c.x === coord.x && c.y === coord.y);
        },

        initializeProperties() {
            if (this.properties && this.properties.properties) {
                try {
                    const propertiesArray = JSON.parse(this.properties.properties);
                    this.parsedProperties = propertiesArray.map(item => ({
                        x: parseFloat(item.x),
                        y: parseFloat(item.y),
                        title: item.title || '',
                        description: item.description || '',
                        image: item.image || ''
                    }));
                    this.imageProperties = this.parsedProperties.map(item => item.image);
                    this.coordinates = this.parsedProperties.map(item => ({
                        x: item.x,
                        y: item.y,
                        image: item.image
                    }));
                } catch (error) {
                    this.parsedProperties = [];
                    this.imageProperties = [];
                    this.coordinates = [];
                }
            } else {
                this.parsedProperties = [];
                this.imageProperties = [];
                this.coordinates = [];
            }
        },

        getCoordinateStyle(coord) {
            const imgElement = this.$refs.mainImage;
            const imgWidth = imgElement ? imgElement.clientWidth : this.imageSize.width;
            const imgHeight = imgElement ? imgElement.clientHeight : this.imageSize.height;
            const xRatio = imgWidth / this.imageSize.width;
            const yRatio = imgHeight / this.imageSize.height;

            let x = coord.x * xRatio;
            let y = coord.y * yRatio;

            x = Math.max(0, Math.min(x, imgWidth - 50));
            y = Math.max(0, Math.min(y, imgHeight - 50));

            return {
                position: 'absolute',
                left: `${x}px`,
                top: `${y}px`,
                zIndex: 10,
            };
        },

        onImageLoad() {
            const imgElement = this.$refs.mainImage;
            this.imageSize = {
                width: imgElement.naturalWidth,
                height: imgElement.naturalHeight
            };
        },

        handleCoordinateClick(coord, event) {
            event.stopPropagation();
            const index = this.selectedCoordinates.findIndex(c => c.x === coord.x && c.y === coord.y);
            if (index === -1) {
                this.selectedCoordinates.push(coord);
                if (this.isCoordinateCorrect(coord)) {
                    const imageIndex = this.coordinates.findIndex(c => c.x === coord.x && c.y === coord.y);
                    if (imageIndex !== -1) {
                        if (!this.selectedImages.includes(imageIndex)) {
                            this.selectedImages.push(imageIndex);
                        }
                        if (!this.imagesCompleted.includes(imageIndex)) {
                            this.imagesCompleted.push(imageIndex);
                            this.foundImagesCount = this.imagesCompleted.length;
                            if (this.foundImagesCount === this.imageProperties.length) {
                                const coordProperty = this.parsedProperties.find(prop => prop.x === coord.x && prop.y === coord.y);
                                if (coordProperty) {
                                    this.showModal(coordProperty, () => {
                                        this.finished();
                                        this.modalMatch = false
                                    });
                                } else {
                                    console.error('No se encontró la propiedad correspondiente para las coordenadas:', coord);
                                }
                            }
                        }
                        const coordProperty = this.parsedProperties.find(prop => prop.x === coord.x && prop.y === coord.y);

                        if (coordProperty) {
                            this.showModal(coordProperty);
                        } else {
                            console.error('No se encontró la propiedad correspondiente para las coordenadas:', coord);
                        }
                    }
                }
            }
        },

        isCoordinateCorrect(coord) {
            return this.coordinates.some(c => c.x === coord.x && c.y === coord.y);
        },

        handleImageClick(event, index) {
            if (this.imagesCompleted.includes(index)) {
                const propertiesArray = JSON.parse(this.properties.properties);

                const property = propertiesArray[index];

                if (property) {
                    const title = property.title;
                    const description = property.description;

                    this.showModal({
                        image: property.image,
                        title: title,
                        description: description
                    });
                } else {
                    console.error("Propiedad no encontrada", index);
                }
            } else {
                const rect = this.$refs.mainImage.getBoundingClientRect();
                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;

                const threshold = 15;
                const foundCoordinate = this.coordinates.find(coord => {
                    const coordX = coord.x * this.imageSize.width / this.$refs.mainImage.clientWidth;
                    const coordY = coord.y * this.imageSize.height / this.$refs.mainImage.clientHeight;
                    return Math.abs(coordX - x) < threshold && Math.abs(coordY - y) < threshold;
                });

                if (foundCoordinate) {
                    this.handleCoordinateClick(foundCoordinate, event);
                } else {
                    this.errorPosition = {
                        x: event.clientX,
                        y: event.clientY,
                    };
                    this.showError = true;
                    setTimeout(() => {
                        this.showError = false;
                    }, 1000);
                }
            }
        },

        handleContainerClick(event) {
            if (event.target.closest('.coordinate-image')) return;
            this.handleImageClick(event);
        },

        handleOutsideClick(event) {
            const container = document.querySelector('.error-svg-container');
            if (container && this.showError && !container.contains(event.target) && !container.contains(event.relatedTarget)) {
                this.resetError();
            }

            const coordinateContainer = this.$refs.coordinateContainer;
            if (coordinateContainer && !coordinateContainer.contains(event.target)) {
                this.showError = true;
                setTimeout(() => {
                    this.showError = false;
                }, 1000);
            }
        },

        getErrorStyle() {
            const imgElement = this.$refs.mainImage;
            const rect = imgElement ? imgElement.getBoundingClientRect() : { left: 0, top: 0 };

            return {
                left: `${this.errorPosition.x - rect.left}px`,
                top: `${this.errorPosition.y - rect.top}px`,
                transform: 'translate(-50%, -50%)',
            };
        },

        resetError() {
            this.showError = false;
        },

        progressColor() {
            if (this.progressPercentage === 0) {
                return '#dcdfe6';
            }
            return this.progressPercentage > 75 ? '#204F9A' : '#204F9A';
        },

        showModal(coord, onCloseCallback) {
            if (coord && coord.image) {
                this.modalTitle = coord.title;
                this.modalDescription = coord.description;
                this.modalImage = coord.image;
                this.modalMatch = true;
            } else {
                this.modalTitle = 'Error';
                this.modalDescription = 'No se encontró la imagen.';
                this.modalImage = '';
                this.modalMatch = false;
            }

            setTimeout(() => {
                if (typeof onCloseCallback === 'function') {
                    onCloseCallback();
                }
            }, 1000);
        },

        closeModal() {
            this.modalMatch = false;
        },
        returnChallenge() {
            window.location.href = '/retos?page=1&option=entertainment';
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    },
}
</script>
